// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__QNvww","authBackgroundImage":"Auth_authBackgroundImage__eUHSG","authContent":"Auth_authContent__hslW2","authTitle":"Auth_authTitle__6kbOs"};